import { compose } from 'lodash/fp';
import { paletteLookup } from '../functions';
import styles from './styles';

const generateTextPalette = paletteGetter =>
   Object.freeze({
      500: paletteGetter(500),
      800: paletteGetter(800)
   });

const textPaletteValidator = shade => {
   if (shade !== 500 && shade !== 800)
      throw new Error(
         `Primary and accent text colors only come in shades of 500 or 800.  The shade [${shade}] is invalid.`
      );
   return shade;
};

export const generateTextTheme = (primaryPaletteGetter, accentPaletteGetter) => {
   const primaryPalette = generateTextPalette(primaryPaletteGetter);
   const accentPalette = generateTextPalette(accentPaletteGetter);

   return {
      styles,
      colors: Object.freeze({
         default: '#222222',
         inverted: '#FFFFFF',
         disabled: '#888888',
         caption: '#595959',
         error: '#a70d20',
         primary: compose(paletteLookup(primaryPalette), textPaletteValidator),
         accent: compose(paletteLookup(accentPalette), textPaletteValidator)
      })
   };
};



// WEBPACK FOOTER //
// ./src/UI/themes/text/index.js